import React, { useState } from "react";
import "./ChatPopup.css";

export default function ChatPopup({ sheetUrl }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (key, value) => {
    setForm((f) => ({ ...f, [key]: value }));
  };

  const onSend = async () => {

    // Kiểm tra bắt buộc
    if (!form.name || !form.phone || !form.message) {
      alert("Vui lòng điền đầy đủ thông tin bắt buộc");
      return;
    }

    if (!sheetUrl) {
      console.error("sheetUrl chưa được set!");
      return;
    }

    try {
      // Chuyển form thành query string
      const query = new URLSearchParams(form).toString();
      const url = `${sheetUrl}?${query}`;
      setSubmitted(true);
      const res = await fetch(url, {
        method: "GET", // dùng GET để tránh CORS preflight
      });

      const text = await res.text();

      // Nếu Apps Script trả JSON
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { success: true }; // fallback nếu trả về HTML
      }

      if (data.success) {
      
        setForm({ name: "", phone: "", email: "", message: "" });
      } else {
        console.error("Lỗi server:", data.error);
        alert("Gửi không thành công, thử lại sau");
      }
    } catch (err) {
      console.error("Google Sheets error:", err);
      alert("Gửi không thành công, thử lại sau");
    }
  };

  return (
    <>
      {open && (
        <div className="ms-panel">
          <div className="ms-header">
            <span>Hỗ trợ khách hàng</span>
            <button onClick={() => setOpen(false)}>×</button>
          </div>

          <div className="ms-form">
            {submitted ? (
              <div className="ms-success">
                Cảm ơn bạn! Chúng tôi sẽ liên hệ sớm.
              </div>
            ) : (
              <>
                <label>Họ tên *</label>
                <input
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                  placeholder="Nhập họ tên"
                />

                <label>Số điện thoại *</label>
                <input
                  value={form.phone}
                  onChange={(e) => handleChange("phone", e.target.value)}
                  placeholder="Nhập số điện thoại"
                />

                <label>Email</label>
                <input
                  value={form.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                  placeholder="Nhập email"
                />

                <label>Nội dung *</label>
                <textarea
                  value={form.message}
                  onChange={(e) => handleChange("message", e.target.value)}
                  placeholder="Bạn cần hỗ trợ gì?"
                  rows="4"
                />

                <button className="ms-send" onClick={onSend}>
                  Gửi thông tin
                </button>
              </>
            )}
          </div>
        </div>
      )}

      <button
        className="chat-fab"
        onClick={() => setOpen((v) => !v)}
        aria-label="Mở chat"
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden
        >
          <path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
        </svg>
      </button>
    </>
  );
}
